import Handlebars from 'handlebars';
import i18next from 'i18next';
import XHR from 'i18next-xhr-backend';

import Config from './config';





const options = {
    debug: false,
    lng: Config.locale(),
    fallbackLng: 'en',
    ns: ['glossary', 'actions', 'labels', 'columns', 'units', 'types', 'dates', 'errors',
        'calendar',
        'filters', 
        'user',
        'type', 'field', 'issue', 'priority', 'status', 'sticker', 'file', 'script', 'contract', 'server',
        'schedule',
        'comment',
        'service.object', 'datatables',
        'configuration', 'capabilities',
        'application', 'forms', 'grids', 'popups', 'navs',
        'auth'],
    nsSeparator: '::',
    backend: {
        loadPath: 'locales/{{lng}}/{{ns}}.json' 
    }
};

export default i18next
    .use( XHR )
    .init( options )
    .then( () => i18next.changeLanguage( Config.locale() ) )
    .then( () => {
        document.title = i( 'application::title' );
        
        Handlebars.registerHelper( 'i', (key, ...other) => {
            return other.pop(), i( key, ...other );
        } );

        return i;
        
        function i(key, ...other) { 
            const [context, more] = other;

            if (typeof context === 'object')
                return i18next.t( key, context );
            
            if (typeof context !== 'number')
                return context !== undefined 
                    ? i18next.t( key, { context } )
                    : i18next.t( key );

            const data = { count: context, more };
            for (let i = 0; i < other.length; i++)
                data[i] = other[i];

            return  i18next.t( key, data );
        }
    } );



// WEBPACK FOOTER //
// ./src/js/i18n.js